import React, { useCallback } from 'react';
import {
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import copyToClipboard from 'copy-to-clipboard';

import AdvancedActionCell from '../action-cell/AdvancedActionCell';
import { CopyIcon } from '../icon/regular';
import { ExternalLinkAltIcon } from '../icon/solid';
import { notify } from '../../store/modules/notifications/actions';
import { Action } from '..';

const useStyles = makeStyles(({ palette, colors }: Theme) => createStyles({
  icon: {
    color: colors.selected,
    width: 16,
    height: 16,
  },
}), { name: 'UrlMenu' });

type Props = {
  url: string;
  disabled?: boolean;
};

const UrlMenu = ({
  url,
  disabled = false,
}: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const visit = useCallback(() => window.open(url, '_blank'), [url]);
  const copy = useCallback(() => {
    if (copyToClipboard(url)) {
      dispatch(
        notify({
          type: 'success',
          icon: 'copy',
          message: 'URL copied successfully.',
        }),
      );
    } else {
      dispatch(
        notify({
          type: 'error',
          icon: 'copy',
          message: 'URL copying failed.',
        }),
      );
    }
  }, [url, dispatch]);

  return (
    <AdvancedActionCell>
      <Action
        onClick={copy}
        icon={<CopyIcon className={classes.icon} />}
        disabled={disabled || !url}
        title="Copy URL"
      />
      <Action
        onClick={visit}
        icon={<ExternalLinkAltIcon className={classes.icon} />}
        disabled={disabled || !url}
        title="Visit Page"
      />
    </AdvancedActionCell>
  );
};

export default UrlMenu;
